module.exports = __webpack_public_path__ + "img/portrait-076.7eeff8df.jpg";